export default {"src":"/_next/static/media/medium.87665f16.svg","height":17,"width":29};